<template>
  <div class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toolbar class="p-mb-4">
          <template v-slot:left>
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="p-button-success p-mr-2 p-mb*2"
              @click="openNew"
            />
          </template>
        </Toolbar>
        <DataTable
          ref="dt"
          :value="unidades"
          class="p-datatable-sm"
          v-model:selection="selectedUnidade"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} unidades"
        >
          <template #header>
            <div
              class="
                table-header
                p-d-flex p-flex-column p-flex-md-row p-jc-md-between
              "
            >
              <h5>Gestão de Unidades</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Pesquisar..."
                />
              </span>
            </div>
          </template>
          <template #empty>
            <div class="p-text-center">Nenhum resultado encontrado...</div>
          </template>

          <Column header="#">
            <template #body="slotProps">
              <span class="p-column-title">#</span>
              {{ slotProps.data.id }}
            </template>
          </Column>
          <Column field="nome" header="Nome" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Nome</span>
              {{ slotProps.data.nome }}
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success p-mr-2"
                @click="openUpdate(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="openDelete(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
  <!-- CADASTRO E ATUALIZAÇÃO-->
  <Dialog
    v-model:visible="unidadeDialog"
    :style="{ width: '480px' }"
    :header="titleDialog"
    :modal="true"
    @hide="hideDialogs()"
  >
    <form @submit.prevent="saveUnidadeOrUpdate(!v$.unidade.$invalid)">
      <div class="p-fluid">
        <div class="p-field">
          <label for="nome">Nome</label>
          <InputText
            id="nome"
            v-model.trim="v$.unidade.nome.$model"
            autofocus
            placeholder="Digite o nome do unidade"
            maxlength="255"
            :class="{ 'p-invalid': submitted && v$.unidade.nome.$invalid }"
          />
          <small class="p-invalid" v-if="submitted && v$.unidade.nome.$invalid"
            >Nome é obrigatório</small
          >
        </div>
      </div>
      <Button
        label="Salvar"
        icon="pi pi-check"
        class="p-button-raised p-mr-2"
        type="submit"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-raised p-button-text"
        @click="hideDialogs()"
      />
    </form>
    <template #footer> </template>
  </Dialog>
  <!-- CADASTRO E ATUALIZAÇÃO-->

  <!-- DELETAR REGISTRO-->
  <Dialog
    v-model:visible="deleteUnidadeDialog"
    :style="{ width: '450px' }"
    :modal="true"
    :header="titleDialog"
    @hide="hideDialogs()"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="unidade"
        >Tem certeza de que deseja excluir o registro <b>{{ unidade.nome }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="Sim"
        icon="pi pi-check"
        class="p-button-raised"
        @click="deleteunidade()"
      />
      <Button
        label="Não"
        icon="pi pi-times"
        class="p-button-raised p-button-text"
        @click="hideDialogs()"
      />
    </template>
  </Dialog>
  <!-- DELETAR REGISTRO-->
</template>
  
  <script>
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import { FilterMatchMode } from "primevue/api";

import UnidadesService from "@/service/Unidades/UnidadesService";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      unidades: null,
      unidadeDialog: false,
      deleteUnidadeDialog: false,
      selectedUnidade: null,
      unidade: {
        id: null,
        nome: null,
      },
      filters: {},
      submitted: false,
      titleDialog: null,
    };
  },
  unidadesService: null,
  validations() {
    return {
      unidade: {
        nome: {
          required,
        },
      },
    };
  },
  created() {
    this.initFilters();
    this.unidadesService = new UnidadesService();
  },
  mounted() {
    this.findAll();
  },
  methods: {
    findAll() {
      this.unidadesService.findAll().then((data) => {
        this.unidades = data;
      });
    },
    openNew() {
      this.titleDialog = "Nova Unidade Gestora";
      this.submitted = false;
      this.unidadeDialog = true;
    },
    openUpdate(unidade) {
      this.unidade = unidade;
      this.titleDialog = this.unidade.nome.toUpperCase();
      this.unidadeDialog = true;
    },
    openDelete(unidade) {
      this.unidade = unidade;
      this.titleDialog = this.unidade.nome.toUpperCase();
      this.deleteUnidadeDialog = true;
    },
    hideDialogs() {
      this.submitted = false;
      this.unidade = {
        id: null,
        nome: null,
      };
      this.selectedUnidade = null;
      this.unidadeDialog = false;
      this.deleteUnidadeDialog = false;
    },
    saveUnidadeOrUpdate(isFormValid) {
      this.submitted = true;
      if (!isFormValid) {
        return;
      }
      if (this.unidade.id == null) {
        this.unidadesService
          .create(this.unidade)
          .then((data) => {
            this.$msgSuccess(data);
            this.findAll();
            this.hideDialogs();
          })
          .catch((error) => {
            this.$msgErro(error);
          });
      } else {
        this.unidadesService
          .update(this.unidade.id, this.unidade)
          .then((data) => {
            this.$msgSuccess(data);
            this.findAll();
            this.hideDialogs();
          });
      }
    },
    deleteunidade() {
      this.unidadesService
        .deleteById(this.unidade.id)
        .then((data) => {
          this.$msgSuccess(data);
          this.findAll();
          this.hideDialogs();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>
  
  <style scoped lang="scss">
.p-invalid {
  color: red;
}
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-datatable-sm .p-datatable-tbody > tr > td .p-column-title {
  display: none !important;
}
@media screen and (max-width: 40em) {
  ::v-deep(.p-datatable) {
    &.p-datatable-sm {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }
        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: right;
        }
        .p-rating {
          display: inline-block;
        }
      }
    }
  }
}
</style>